import { MinzeElement } from "minze";

export interface TjNextArrowIcon {}

export class TjNextArrowIcon extends MinzeElement {
  html = () => `
    <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.66699 16.9189H25.3337" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M16 7.58557L25.3333 16.9189L16 26.2522" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  css = () => `
    
  `;
}
